import produce from 'immer'
import { SET_VISITED_PROFILE } from './constants';

export const initialState = {
    visitedProfile: null
}

const homeReducer = (state = initialState, action) => 
    produce(state, (draft) => {
        // eslint-disable-next-line default-case
        switch (action.type) {
            case SET_VISITED_PROFILE:
                draft.visitedProfile = action.data;
                break;
        }
    })


export default homeReducer;
